import React, { Fragment } from "react";
import { Typography } from "@mui/material";
import { t } from "i18next";
import { BtmReturnReportedProduct } from "../model/btm-return-reported-product";

interface IBtmRequestDetailsReportedProductsProps {
    declaredProducts: BtmReturnReportedProduct[];
}

export const BtmRequestDetailsReportedProducts = (props: IBtmRequestDetailsReportedProductsProps) => {
    return props.declaredProducts.map(product =>
        <div className={"btm-request-product__list"} key={`product-id-${product.id}`}>
            <Fragment>
                <div className={"btm-request-product__line"}>
                    <div className={"btm-request-product__column"}>
                        <Typography variant={"h5"} className={"btm-request-product__label"} color={"textSecondary"}>
                            {t("components.blueBrandReturns.page.products.name")}
                        </Typography>
                        <Typography>{product.name}</Typography>
                    </div>
                    <div className={"btm-request-product__column"}>
                        <Typography variant={"h5"} className={"btm-request-product__label"} color={"textSecondary"}>
                            {t("components.blueBrandReturns.page.products.quantity")}
                        </Typography>
                        <Typography>{product.quantity}</Typography>
                    </div>
                </div>
                <div className={"btm-request-product__line"}>
                    <div className={"btm-request-product__column"}>
                        <Typography variant={"h5"} className={"btm-request-product__label"} color={"textSecondary"}>
                            {t("components.blueBrandReturns.page.products.reason")}
                        </Typography>
                    </div>
                    <div className={"btm-request-product__column"}>
                        <Typography>{product.returnReason}</Typography>
                    </div>
                </div>
            </Fragment>
        </div>);
};
